import {Locale, Site, findLocaleFromUrlAndCookie, findSiteFromUrl} from "@zooplus/commons-lang";

export function getLocale(site: Site): Locale {
  return findSiteFromUrl() ? (findLocaleFromUrlAndCookie() ?? site.locale) : site.locale
}

export function getLang(site: Site): string {
  return getLocale(site).split('-')[0];
}
